import { Link, useHistory } from "react-router-dom";
import React, { useRef, useEffect, useCallback,useState } from 'react';
//import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';
import axios from "../../services/axios";

import { useParams } from "react-router-dom";

import  "./Player.css";
import { Details } from "@material-ui/icons";
const Background = styled.div`
  width: 100%;
  height:100%;
  background: rgba(0, 0, 0, 0.8);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalWrapper = styled.div`
  width: 500px;
  height: 400px;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
  background: #fff;
  color: #000;
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  z-index: 10;
  border-radius: 10px;
  margin-top: 30px;
  margin-bottom :150px
`;

const ModalImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px 0 0 10px;
  background: #000;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  line-height: 1.8;
  color: #141414;

  p {
    margin-bottom: 1rem;
  }

  button {
    padding: 10px 24px;
    background: #141414;
    color: #fff;
    border: none;
  }
`;

const CloseModalButton = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  padding: 0;
  z-index: 10;
`;

function PlayerShow ()
{
    const [player,setPlayer]=useState();
    const {assetId} =useParams();
    const [show,setShow]= useState(false);
    const [lang,setLang]= useState('cat');
    const[detail,setDetail]=useState();
    useEffect(() => {
        /*call service*/
        async function fetchData() {
            const request = await axios.get(`/asset/${assetId}/lang/${lang}`);
            console.log('Taking response::'+request);
            setDetail(request.data);
            setPlayer(`<iframe width="100%" height="100%" scrolling="no" allowfullscreen frameborder="no" allow="autoplay" src=${request.data?.webPublicUrl}></iframe>`);

            if(localStorage.getItem("token"))
            {
              setShow(true);  
            }
            else{
              setShow(false);
              window.open("/educatiuprofessionals","_self");  
            }
           
            return request;
          }
          fetchData();
        /*end call service*/
     
      
  },[]);
  
  function Iframe(props) {
    return (
      <div className="heightplayer"
        dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
      />
    );
  }
  
  if(show)
  {
    return (<Iframe iframe={player} allow="autoplay" />);

  }
  if(!show)
  {
    return (<></>);
  }
  
 

}
export default PlayerShow;


